import * as React from 'react'

export function InspectorHeading({
  label,
  count
}: {
  label: string
  count?: number
}): React.ReactElement {
  return (
    <div className="flex items-baseline gap-2">
      <h4 className="m-0 text-10 font-semibold uppercase tracking-[0.07em] text-ink-3">{label}</h4>
      {count !== undefined && <span className="font-mono text-10 text-ink-4">{count}</span>}
    </div>
  )
}
